import type { OptionsDocument, QuoteDocument } from 'paintscout'
import { uuid } from '../../util/uuid'
import { calculateQuote } from '../util/calculate/calculate-quote'

export function copyAreaSubstrate(args: {
  quote: QuoteDocument
  options: OptionsDocument
  areaKey: string
  key: string
}): QuoteDocument {
  const { quote, options, areaKey, key } = args
  const substrates = { ...quote.areas[areaKey].substrates }
  const newKey = uuid()
  Object.keys(substrates).forEach((section) => {
    const substrateSection = substrates[section]
    const substrateToCopy = substrateSection.find((substrate) => substrate.key === key)
    if (substrateToCopy) {
      substrates[section] = [...substrateSection, { ...substrateToCopy, key: newKey }]
    }
  })

  const index = quote.areas[areaKey].substrateOrder.findIndex((orderItem) => orderItem.key === key)

  if (index === -1) {
    return quote
  }

  const orderItem = { type: 'areaSubstrate', key: newKey }
  const substrateOrder = quote.areas[areaKey].substrateOrder ?? []
  substrateOrder.splice(index, 0, orderItem)

  return calculateQuote({
    quote: {
      ...quote,
      areas: {
        ...quote.areas,
        [areaKey]: {
          ...quote.areas[areaKey],
          substrates,
          substrateOrder
        }
      }
    },
    options
  })
}
